import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Typography, Divider } from '@mui/material';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box 
      component="footer" 
      sx={{ 
        mt: 'auto',
        py: 3,
        backgroundColor: '#f8f9fa',
        borderTop: '1px solid',
        borderColor: 'divider'
      }}
    >
      <Container maxWidth="xl">
        <Box sx={{ 
          display: 'flex', 
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          {/* Legal Links */}
          <Box sx={{ 
            display: 'flex', 
            gap: 3,
            flexWrap: 'wrap',
            alignItems: 'center'
          }}>
            <Link 
              to="/terms" 
              style={{ 
                textDecoration: 'none', 
                color: 'inherit'
              }}
            >
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{ '&:hover': { color: 'primary.main' } }}
              >
                Terms of Service
              </Typography>
            </Link>

            <Link 
              to="/acceptableuse" 
              style={{ 
                textDecoration: 'none', 
                color: 'inherit'
              }}
            >
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{ '&:hover': { color: 'primary.main' } }}
              >
                Acceptable Use
              </Typography>
            </Link>

            <Link 
              to="/privacy" 
              style={{ 
                textDecoration: 'none', 
                color: 'inherit'
              }}
            >
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{ '&:hover': { color: 'primary.main' } }}
              >
                Privacy Policy
              </Typography>
            </Link>

            <Link 
              to="/cookies" 
              style={{ 
                textDecoration: 'none', 
                color: 'inherit'
              }}
            >
              <Typography 
                variant="body2" 
                color="text.secondary"
                sx={{ '&:hover': { color: 'primary.main' } }}
              >
                Cookie Policy
              </Typography>
            </Link>
          </Box>

          {/* Copyright */}
          <Typography 
            variant="body2" 
            color="text.secondary"
            sx={{ mt: { xs: 2, sm: 0 } }}
          >
            © {currentYear} apply-bridge. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;